module.exports = __webpack_public_path__ + "img/11088032_L.18cda7d5.png";